import { L10n } from '../L10n/L10n';
import { Module } from '../Module';

export interface ILocalizedDateFilter {
  (value: any): string;
}

Module.instance().filter('localizedDate', (): ILocalizedDateFilter => {
  return L10n.localizedDate;
});

Module.instance().filter('localizedDateTime', (): ILocalizedDateFilter => {
  return L10n.localizedDateTime;
});
